export const isEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b)
}
